import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { PERSIST_STORE_NAME } from 'constants/app.constant'
import deepParseJson from './deepParseJson'

export default function getAuthHeader() {
    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
    const persistData = deepParseJson(rawPersistData)
    const accessToken = persistData?.auth?.session?.token

    return {
        'Content-Type': 'application/json',
        ...(accessToken ? { [REQUEST_HEADER_AUTH_KEY]: `${TOKEN_TYPE}${accessToken}` } : {})
    }
}
